import axios, { AxiosResponse } from 'axios'
import { deepClean } from './utility/jsonFunctions'
import { getUserToken } from './utility/localStorageFunctions'
import { TaxiRate, TaxiRates } from './vehicle/taxisRatesAPI.types'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/clients-api/clients`

const getTaxiRates = async (
  clientId: number,
): Promise<AxiosResponse<TaxiRates>> => {
  // console.log(`get client Taxi Rates()`)
  const token = await getUserToken('clients')
  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${clientId}/taxiRates`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const createTaxiRates = async (taxiRate: TaxiRate, clientId: number) => {
  deepClean(taxiRate)
  console.log(`create client Taxi Rates() data API: `, taxiRate)
  const token = await getUserToken('clients')
  const response = await axios({
    method: 'post',
    url: BASE_URL?.concat(`/${clientId}/taxiRates`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...taxiRate,
      },
    },
  })
  return response
}
const getTaxiRateById = async (
  clientId: number,
  taxiRateId: number,
): Promise<AxiosResponse<TaxiRate>> => {
  console.log(`getTaxiRateById(${taxiRateId})`)
  const token = await getUserToken('clients')
  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${clientId}/taxiRates/${taxiRateId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  console.log('getTaxiRateById response: ', response)
  return response
}

const deleteTaxiRate = async (taxiRateId: number) => {
  console.log(`deleteTaxiRate(${taxiRateId})`)
  const token = await getUserToken('clients')
  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${taxiRateId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const updateTaxiRateById = async (
  clientId: number,
  taxiRateId: number,
  data: TaxiRate,
) => {
  deepClean(data)
  console.log(`update client Taxi Rates() data API: `, taxiRateId, data)
  const token = await getUserToken('clients')
  const response = await axios({
    method: 'patch',
    url: BASE_URL?.concat(`/${clientId}/taxiRates/${taxiRateId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...data,
      },
    },
  })
  console.log('updateTaxiRateById response: ', response)
  return response
}

export const clientTaxiRatesAPI = {
  getTaxiRates,
  createTaxiRates,
  getTaxiRateById,
  deleteTaxiRate,
  updateTaxiRateById,
}
